import { useUnit } from 'effector-react'
import {
  $goldenMayStatus,
  $totalCountOfWinners,
  $winners,
  getWinnersFx,
} from './model'

export const useWinnersList = () => {
  const winners = useUnit($winners)
  const loading = useUnit(getWinnersFx.pending)
  const totalCountOfWinners = useUnit($totalCountOfWinners)

  return { winners, totalCountOfWinners, loading }
}

export const useGoldenMayStatus = () => useUnit($goldenMayStatus)
